import React from "react";
import { Assignable, Tag } from "@planzone/dto";
import { useAssignTag } from "@planzone/view-models";
import { TagIcon } from "@common/tagList/tagIcon";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { TagForm } from "@common/tagForm";
import { Props } from "./type";
import styles from "./styles.scss";

function ButtonTagForm(props: Props) {
  const { isRequestPending, assignTag } = useAssignTag();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.iconBox}>
          {!isRequestPending && show && (
            <div onClick={isVisible ? hide : show}>
              <TagIcon className={styles.icon} />
            </div>
          )}
          {isVisible && (
            <div className={styles.form}>
              <TagForm
                filters={props.tags}
                type={
                  props.type === Assignable.PROJECT
                    ? "projects"
                    : props.type === Assignable.RESSOURCE
                      ? "resources"
                      : "elements"
                }
                submit={(tag: Tag) => {
                  assignTag({
                    project: props.project,
                    assignable: props.type as Assignable,
                    assignableId: props.id,
                    tag,
                  });
                  hide();
                }}
              />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ButtonTagForm };
